<template>
  <div class="viedo-upload" :style="isSingle ? 'display:inline-block' : ''">
    <!-- 视频上传组件测试 -->
    <div class="video-show" v-if="videoCover">
      <el-image class="avatar" :src="videoCover">
        <el-image slot="error" :src="no_pic"></el-image>
      </el-image>
      <div class="video-mask">
        <span class="del-btn" @click="handleDel">
          <i class="el-icon-close"></i>
        </span>
        <span class="preview-btn" @click="handlePreview">
          <i class="el-icon-ai44"></i>
        </span>
      </div>
    </div>
    <el-upload
      v-else
      ref="upload"
      class="avatar-uploader"
      action="#"
      :auto-upload="false"
      :accept="limitSuffix"
      :file-list="fileList"
      :show-file-list="false"
      :before-upload="beforeUpload"
      :on-change="handleChanges"
      :multiple="true"
      :file="file"
      :limit="1"
    >
      <div class="avatar-uploader-icon" slot="default">
        <template v-if="uploading">
          <i class="el-icon-loading"></i>
          <span class="upload-text">上传中</span>
        </template>
        <i v-else class="el-icon-video-camera"></i>
      </div>
    </el-upload>
  </div>
</template>
<script>
import OSSClient from '@components/Uploads/OSS-client';
import no_pic from '@/assets/images/no_pic.png';
export default {
  // model: {
  //   prop: 'videoList',
  //   event: 'change'
  // },
  props: {
    isSingle: {
      type: Boolean,
      default: false,
    },
    file: {
      type: [String, Object],
      default: '',
    },
    limitSize: {
      type: Number,
      default: 500,
    },
    videoList: {
      type: Array,
      default: () => {
        return null;
      },
    },
  },
  data() {
    return {
      videoUrl: '',
      videoCover: '',
      uploading: false,
      errmsg: '',
      fileList: [],
      limitSuffix: '.mp4',
      no_pic,
    };
  },
  watch: {
    videoList: {
      handler(v) {
        if (v && v[0]) {
          this.videoUrl = v[0].originUrl;
          this.videoCover = v[0].videoCover;
        } else {
          this.videoUrl = '';
          this.videoCover = '';
        }
      },
      deep: true,
      immediate: true,
    },
    //  多个视频上传
    file: {
      handler(val) {
        if (this.isSingle) return;
        if (val == '' || 'originUrl' in val) {
          this.videoUrl = val?.originUrl || '';
          this.videoCover = val?.videoCover || '';
        } else {
          this._file_limit(val.raw).then(limitRes => {
            if (limitRes.success) {
              this.errmsg = '';
              this.fileList = [val];
              this.$nextTick(() => {
                this.$refs.upload.submit(); // 手动打开upload的上传行为，就可以触发 before-upload事件了
              });
            } else {
              this.$refs.upload.clearFiles(); // 清空已上传的列表
              this.$message.error(limitRes.errmsg);
              this.$emit('del');
            }
          });
        }
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    companyId() {
      return this.$store.getters.userInfo.companyId;
    },
  },
  methods: {
    async handleChanges(file, fileList) {
      if (this.isSingle) {
        const limitRes = await this._file_limit(file.raw);
        // 说明效验通过
        if (limitRes.success) {
          this.errmsg = '';
          this.fileList = [file];
          this.$refs.upload.submit(); // 手动打开upload的上传行为，就可以触发 before-upload事件了
        } else {
          this.$refs.upload.clearFiles(); // 清空已上传的列表
          return this.$message.error(limitRes.errmsg);
        }
      } else {
        this.$emit('change', file, fileList);
      }
    },
    // 视频效验
    _file_limit(file) {
      return new Promise((resolve, reject) => {
        // 视频文件格式校验
        const isType = ['video/mp4'].includes(file.type);
        if (!isType) {
          resolve({ errmsg: '视频格式仅限MP4，请重新上传' });
          return;
        }
        const isLimitSize = file.size / 1024 / 1024 < this.limitSize;
        if (!isLimitSize) {
          resolve({ errmsg: '视频大小不能超过500M，请重新上传”' });
          return;
        }
        resolve({ success: true });
        _videoElement.src = URL.createObjectURL(file);
      });
    },

    beforeUpload(file) {
      this.uploading = true; // 改为上传中的状态
      this._upload(file); // 将视频上传到oss
      return false;
    },
    _upload(file) {
      // 分片上传
      const success = res => {
        this.uploading = false;
        this.errMsg = '';
        this.videoUrl = `http://${res.bucket}.oss-cn-zhangjiakou.aliyuncs.com/${res.name}`;
        this.videoUrl = this.videoUrl.replace('erp-storage-img-new.oss-cn-zhangjiakou.aliyuncs.com', 'erp-storage-img-new.superboss.cc');
        this.videoCover = `http://${res.bucket}.oss-cn-zhangjiakou.aliyuncs.com/${res.name}?x-oss-process=video/snapshot,t_0,f_jpg`;
        this.videoCover = this.videoCover.replace(
          'erp-storage-img-new.oss-cn-zhangjiakou.aliyuncs.com',
          'erp-storage-img-new.superboss.cc'
        );
        this.$emit('upload-success', {
          originUrl: this.videoUrl,
          videoCover: this.videoCover,
        });
      };
      const fail = err => {
        this.uploading = false;
        this.errMsg = '上传失败';
        return this.$message.error(this.errmsg);
      };
      // OSSClient.getInstance().singleUpload(`scm/${this.companyId}/${Date.now()}/${file.name}`, file, {
      //     success: success,
      //     fail: fail
      // })
      OSSClient.getInstance().multipartUpload(`scm/${this.companyId}/${Date.now()}/${file.name}`, file, {
        success: success,
        fail: fail,
      });
    },
    handleDel() {
      if (this.isSingle) {
        this.fileList = [];
        this.videoUrl = '';
        this.videoCover = '';
      }
      this.$emit('del');
    },
    handlePreview() {
      window.open(this.videoUrl);
    },
  },
};
</script>

<style lang="scss" scoped>
.viedo-upload {
  margin-right: 10px;
}
.avatar-uploader ::v-deep .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  width: 80px;
  height: 80px;
  font-size: 28px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #ccc;
}
.upload-text {
  font-size: 12px;
  margin-top: 5px;
}
.avatar {
  width: 82px;
  height: 82px;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
}

.video-show {
  position: relative;
  // width: 84px;
  // height: 93px;
}
.video-mask {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 9px;
  right: 0;
  color: #ffffff;
  .del-btn {
    display: none;
    position: absolute;
    cursor: pointer;
    width: 20px;
    height: 20px;
    top: 0;
    right: 0;
    border-radius: 50%;
    transform: translate(45%, -45%);
    color: #fff;
    font-size: 12px;
    background-color: rgba(0, 0, 0, 0.4);
    text-align: center;
    line-height: 20px;
  }
  .preview-btn {
    display: none;
    position: absolute;
    cursor: pointer;
    right: 0;
    bottom: 0;
    width: 26px;
    height: 26px;
    border-top-left-radius: 6px;
    border-bottom-right-radius: 4px;
    background-color: rgba(0, 0, 0, 0.4);
    text-align: center;
    line-height: 26px;
  }
}
.video-mask:hover {
  .del-btn {
    display: block;
  }
  .preview-btn {
    display: block;
  }
}
</style>
